import {NgModule} from '@angular/core';

import {i18nPipe} from './i18nPipe';

@NgModule({
    declarations: [
        i18nPipe
    ],
    exports: [
        i18nPipe
    ],
})
export class I18nPipeModule { }



// WEBPACK FOOTER //
// ./src/app/shared/_utils/pipes/i18nPipe.module.ts